var map = {
	"./": [
		82
	],
	"./components/TriviaExitPopup": [
		290,
		9
	],
	"./components/TriviaExitPopup.tsx": [
		290,
		9
	],
	"./icons/CloseIcon": [
		150
	],
	"./icons/CloseIcon.tsx": [
		150
	],
	"./icons/FullIcon": [
		287,
		10
	],
	"./icons/FullIcon.tsx": [
		287,
		10
	],
	"./icons/MenuIcon": [
		291,
		11
	],
	"./icons/MenuIcon.tsx": [
		291,
		11
	],
	"./icons/XIcon": [
		292,
		12
	],
	"./icons/XIcon.tsx": [
		292,
		12
	],
	"./index": [
		82
	],
	"./index.tsx": [
		82
	],
	"./text.style": [
		288,
		13
	],
	"./text.style.ts": [
		288,
		13
	],
	"./types": [
		133
	],
	"./types.ts": [
		133
	],
	"./v1": [
		165,
		3
	],
	"./v1/": [
		165,
		3
	],
	"./v1/index": [
		165,
		3
	],
	"./v1/index.tsx": [
		165,
		3
	],
	"./v2": [
		169,
		2
	],
	"./v2/": [
		169,
		2
	],
	"./v2/index": [
		169,
		2
	],
	"./v2/index.tsx": [
		169,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 437;
module.exports = webpackAsyncContext;